import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import ApiService from './apiService';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export const NearestClubServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: '/bin/lt', // generic base to allow for '/nearestClubServlet' or '/nearestClubServlet.locator.json'
	headers: {
		'Content-Type': 'application/json; charset=UTF-8'
	}
});

export default class NearestClubService
	extends ApiService
	implements ltFramework.INearestClubService {
	constructor() {
		super('nearest-club-service', NearestClubServiceAxiosInstance);
	}

	public getNearestClub(): AxiosPromise<ltFramework.IClubFromService[]> {
		return this.axiosInstance.get('nearestClubServlet?distance=9999&limit=1');
	}

	public getNearestClubs(
		query: ltFramework.INearestClubQueryObject,
		isLocator = false
	): AxiosPromise<ltFramework.IClubFromService[]> {
		const url = isLocator ? 'nearestClubServlet.locator.json' : 'nearestClubServlet';
		return this.axiosInstance.get(url, { params: query });
	}

	public getClubsByCoordinate(
		coordinate: ltFramework.ICoordinate
	): AxiosPromise<ltFramework.IClubFromService[]> {
		return this.axiosInstance.get(
			`nearestClubServlet?latitude=${coordinate.latitude}&longitude=${coordinate.longitude}`
		);
	}
}

export const nearestClubService = new NearestClubService();
